import { type Branch, type Branchcategory } from "@entities/branch";

export const mockBranchcategories: Branchcategory[] = [
  {
    id: "bc-1",
    tenant_id: "1",
    name: "Produktion",
    color: "#8B5CF6",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "bc-2",
    tenant_id: "1",
    name: "Verkaufsfiliale",
    color: "#10B981",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "bc-3",
    tenant_id: "1",
    name: "Verwaltung",
    color: "#3B82F6",
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

export const mockBranches: Branch[] = [
  // Hauptstandorte Region Mannheim
  {
    id: "branch-1",
    tenant_id: "1",
    name: "Backstube Zentrale",
    branchcategory_id: "bc-1",
    street: "Industriestraße 15",
    zip: "68169",
    city: "Mannheim",
    country: "DE",
    phone: "+49 621 1234500",
    latitude: 49.5069,
    longitude: 8.4692,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "branch-2",
    tenant_id: "1",
    name: "Filiale Marktplatz",
    branchcategory_id: "bc-2",
    street: "Marktplatz 3",
    zip: "68161",
    city: "Mannheim",
    country: "DE",
    phone: "+49 621 1234501",
    latitude: 49.4875,
    longitude: 8.466,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "branch-3",
    tenant_id: "1",
    name: "Filiale Neckarstadt",
    branchcategory_id: "bc-2",
    street: "Mittelstraße 42",
    zip: "68169",
    city: "Mannheim",
    country: "DE",
    phone: "+49 621 1234502",
    latitude: 49.5012,
    longitude: 8.4789,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "branch-4",
    tenant_id: "1",
    name: "Filiale Ludwigshafen",
    branchcategory_id: "bc-2",
    street: "Bismarckstraße 89",
    zip: "67059",
    city: "Ludwigshafen",
    country: "DE",
    phone: "+49 621 1234503",
    latitude: 49.4774,
    longitude: 8.4452,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "branch-5",
    tenant_id: "1",
    name: "Filiale Heidelberg Altstadt",
    branchcategory_id: "bc-2",
    street: "Hauptstraße 112",
    zip: "69117",
    city: "Heidelberg",
    country: "DE",
    phone: "+49 6221 1234504",
    latitude: 49.4094,
    longitude: 8.7063,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "branch-6",
    tenant_id: "1",
    name: "Filiale Weinheim",
    branchcategory_id: "bc-2",
    street: "Bahnhofstraße 25",
    zip: "69469",
    city: "Weinheim",
    country: "DE",
    phone: "+49 6201 1234505",
    latitude: 49.5489,
    longitude: 8.6693,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "branch-7",
    tenant_id: "1",
    name: "Filiale Schwetzingen",
    branchcategory_id: "bc-2",
    street: "Carl-Theodor-Straße 8",
    zip: "68723",
    city: "Schwetzingen",
    country: "DE",
    phone: "+49 6202 1234506",
    latitude: 49.3839,
    longitude: 8.5722,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "branch-8",
    tenant_id: "1",
    name: "Verwaltung",
    branchcategory_id: "bc-3",
    street: "Augustaanlage 7",
    zip: "68165",
    city: "Mannheim",
    country: "DE",
    phone: "+49 621 1234507",
    latitude: 49.4829,
    longitude: 8.4833,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  // Vorlagen-Standorte
  {
    id: "branch-template-1",
    tenant_id: "1",
    name: "Vorlage: Verkaufsfiliale Standard",
    branchcategory_id: "bc-2",
    is_template: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "branch-template-2",
    tenant_id: "1",
    name: "Vorlage: Backstube",
    branchcategory_id: "bc-1",
    is_template: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: "branch-template-3",
    tenant_id: "1",
    name: "Vorlage: Bürostandort",
    branchcategory_id: "bc-3",
    is_template: true,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];
